"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_83_19_3 = void 0;
/**
 * map AllowedOeffnungsausrichtungen to AllowedKetteOpeningPrinciples and
 * remove AllowedOeffnungsausrichtungen
 */
const migration_83_19_3 = (json) => {
    var _a, _b, _c, _d;
    if (((_b = (_a = json.Kette) === null || _a === void 0 ? void 0 : _a.ArtNr) === null || _b === void 0 ? void 0 : _b['US']) === 'ROLECHAIN__undefined' && ((_d = (_c = json.Kette) === null || _c === void 0 ? void 0 : _c.ArtNr) === null || _d === void 0 ? void 0 : _d['DE'])) {
        json.Kette.ArtNr['US'] = json.Kette.ArtNr['DE'].replace(/\./g, '-');
    }
    // we removed ArtNrDE and ArtNrUS completly.. so no need for this anymore!
    // if (json.Kette?.ArtNrUS === 'ROLECHAIN__undefined' && json.Kette?.ArtNrDE) {
    //   json.Kette.ArtNrUS = json.Kette?.ArtNrDE?.replace(/\./g, '-');
    // }
    return json;
};
exports.migration_83_19_3 = migration_83_19_3;
//# sourceMappingURL=migration_83_19_3.js.map